<template>
  <div class="box">
    <!-- 职位展示 -->
    <div
      class="Service-body firm-clickable"
      v-for="(item, index) in listArr"
      :key="index"
      @click="handelAskForHelp(item)"
    >
      <!-- 图片 -->
      <img class="product-img" src="" alt="" />
      <!-- 公司名 -->
      <p class="product-name">洪驰供应链管理公司logo设计</p>
      <!-- 价格 评分 -->
      <div class="Price-Score">
        <p>￥ 2000</p>
        <div>4.6</div>
      </div>
      <!-- 销量 完成率 ... -->
      <div class="Sales-Volume">
        <p>销量：123</p>
        <p>好评：111</p>
        <p>完成率：100%</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 点击模块
    handelAskForHelp(item) {
      this.$emit("handelAskForHelp", item);
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .Service-body:hover {
    // border: 1px solid #409eff ;
    box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
  }
  .Service-body {
    padding: 10px;
    width: 250px;
    min-height: 200px;
    font-size: 14px;
    position: relative;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    margin-right: 20px;
    margin-bottom: 20px;

    // 图片
    .product-img {
      width: 100%;
      height: 100px;
      background: #eeeeee;
      margin-top: 10px;
    }
    // 商品名称
    .product-name {
      width: 100%;
      margin-top: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    // 价格评分
    .Price-Score {
      width: 100%;
      height: 20px;
      line-height: 20px;
      display: flex;
      position: relative;
      margin-top: 10px;
      p {
        font-size: 16px;
        color: #fe574a;
      }
      div {
        width: 25px;
        height: 20px;
        background: #fe574a;
        border: 1px solid #fe574a;
        border-radius: 5px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        position: absolute;
        right: 0;
      }
    }
    //销量 好评 完成率
    .Sales-Volume {
      width: 100%;
      height: 14px;
      line-height: 14px;
      font-size: 12px;
      color: #666666;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
  .Service-body:nth-child(4) {
    margin-right: 0px;
  }
  .Service-body:nth-child(8) {
    margin-right: 0px;
  }
}
</style>
